module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Medium.c659bfb.woff";